module.exports = __webpack_public_path__ + "img/CloseIconGreen.ebf47b29.svg";